import GridShape from "../../components/common/GridShape";
import { Link } from "react-router";
import PageMeta from "../../components/common/PageMeta";

export default function NotFound() {
  return (
    <>
      <PageMeta
        title="Page not found | Poultry Book"
        description="The page you are looking for does not exist."
      />
      <div className="relative flex flex-col items-center justify-center min-h-screen p-6 overflow-hidden z-1">
        <GridShape />
        <div className="mx-auto w-full max-w-[242px] text-center sm:max-w-[472px]">
          <h1 className="mb-8 font-display font-semibold text-gray-800 text-title-md dark:text-white/90 xl:text-title-2xl">
            Not found
          </h1>

          {/* Was two <img src="/images/error/404*.svg">, against a
              `public/images/error/` that does not exist — so the page whose
              job is to explain a missing thing was itself rendering two
              broken images. The number is the illustration now. */}
          <p
            aria-hidden
            className="font-display text-[7rem] font-semibold leading-none tracking-tight text-gray-900/10 num sm:text-[11rem] dark:text-white/10"
          >
            404
          </p>

          <p className="mt-6 mb-6 text-base text-gray-700 dark:text-gray-400 sm:text-lg">
            We can’t seem to find the page you are looking for!
          </p>

          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white px-5 py-3.5 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200"
          >
            Back to Home Page
          </Link>
        </div>
        {/* <!-- Footer --> */}
        <p className="absolute text-sm text-center text-gray-500 -translate-x-1/2 bottom-6 left-1/2 dark:text-gray-400">
          &copy; {new Date().getFullYear()} Poultry Book
        </p>
      </div>
    </>
  );
}
